module.exports = __webpack_public_path__ + "img/FGr_Beleuchtung.d179281a.svg";